export enum SocialLoginType {
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE'
}

export interface StateAfterAuth {
  pathAfterAuth: string;
  socialLogin?: boolean;
  socialLoginType?: SocialLoginType;
  queryParams?: {
    [key: string]: any;
  };
}

export interface SocialLogin {
  isSocialLogin?: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  type?: SocialLoginType;
  error?: boolean;
}
